import { useState } from "react";
import { Check, ChevronsUpDown, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const CompteSelect = ({ value, comptes, onChange, memo, testId }) => {
  const [open, setOpen] = useState(false);
  const choisir = (v) => { setOpen(false); if (v !== value) onChange(v); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="h-9 w-full justify-between font-normal text-left bg-white" data-testid={testId}>
          <span className={`truncate ${value ? (memo ? "text-slate-600 italic" : "text-slate-900") : "text-slate-400"}`}>{value || "Choisir un compte du plan comptable"}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 ml-2 shrink-0 text-slate-400" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(560px,90vw)] p-0" align="start">
        <Command>
          <CommandInput placeholder="Numéro ou nom du compte…" data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>Aucun compte trouvé.</CommandEmpty>
            {value && <CommandItem value="__retirer__" onSelect={() => choisir("")} className="text-red-600"><X className="h-3.5 w-3.5 mr-2" />Retirer le compte</CommandItem>}
            {comptes.map((c) => (
              <CommandItem key={c.libelle} value={`${c.libelle} ${c.parent || ""}`} onSelect={() => choisir(c.libelle)} data-testid={`${testId}-option`}>
                <Check className={`h-3.5 w-3.5 mr-2 shrink-0 ${value === c.libelle ? "opacity-100" : "opacity-0"}`} />
                <div className="min-w-0">
                  <p className="truncate">{c.libelle}</p>
                  {c.parent && <p className="truncate text-[11px] text-slate-400">{c.parent}</p>}
                </div>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
